
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
// import { Breadcrumb,} from 'components';
import SearchForm, {SearchFormItem} from "../../../components/SearchForm";
import { Input, Card, DatePicker, Button, Select} from 'antd';
import Table from './Table';
// import Form from './Form';
import store from './store';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { ReloadOutlined, VerticalAlignBottomOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './index.module.less';

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const {t, i18n} = useTranslation()
  const [searchType,setSearchType] = useState(false);
  useEffect(() => {
    store.fetchRecords()
  }, [])

  const handleExport = ()=>{
    store.onExport()
  }
  const handleSearch = (v)=>{
    store.fetchRecords()
  }
  const resetSearch = ()=>{
    store.pageNo = 1;
    store.pageSize = 10;
    store.pageTotal = 0;
    store.projectNo = null;
    store.orgName = null;
    store.status = null;
    store.manageUserName = null;
    store.updateUserName = null;
    store.updateTime = null;
    store.fetchRecords()
  }


  const { RangePicker } = DatePicker;
  const { Option } = Select;


  return (
    <React.Fragment>
       <div className={[styles.cart].join(" ")}>
        <div className={styles.listTitle}>
            <span className={styles.title}>{t('项目管理')}</span>
          </div>
        <Card style={{ marginBottom: '0.0521rem' }} className={styles.card_searchForm}>
        <div className={!searchType?styles.searchFormContainer:''}>
          {/* <SearchForm style={{display:searchType?'none':'block',flex:'0,0,400px'}}>
            <SearchFormItem span={24} title='关键字识别'>
              <Input allowClear style={{ minWidth: '300px'}} value={store.s_cname} onChange={e => store.s_cname = e.target.value}
                placeholder="请输入项目号、负责人、申请人模糊搜索" />
            </SearchFormItem>
          </SearchForm> */}
          <SearchForm isExport={true} onFinish={(v)=>{handleSearch(v)}} onExport={handleExport} onReset={resetSearch}>
            <SearchFormItem span={8} name="projectNo" title='项目号'>
              <Input allowClear value={store.projectNo} onChange={e => store.projectNo = e.target.value || null}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} name="manageUserName" title='负责人'>
              <Input allowClear value={store.manageUserName} onChange={e => store.manageUserName = e.target.value || null}
                placeholder="请输入" />
            </SearchFormItem>
            <SearchFormItem span={8} name="status" title='使用状态'>
                <Select style={{ minWidth: '0.5208rem', fontSize:"0.0625rem"}} allowClear value={store.status} placeholder='请选择' onChange={e => store.status = e}>
                    {/* <Option value="0">全部</Option> */}
                    <Option value="1">启用</Option>
                    <Option value="0">禁用</Option>
                </Select>
            </SearchFormItem>
            {/* <SearchFormItem span={8} name="orgName" title='客户'>
              <Input allowClear value={store.orgName} onChange={e => store.orgName = e.target.value || null}
                  placeholder="请输入" />
            </SearchFormItem> */}
            <SearchFormItem span={8} name="applyUserName" title='申请人'>
              <Input allowClear value={store.applyUserName} onChange={e => store.applyUserName = e.target.value || null}
                placeholder="请输入" />
            </SearchFormItem>
            {/* <SearchFormItem span={8} name="updateTime" title='最后操作时间'>
            <RangePicker allowClear style={{width:230}} value={store.updateTime} locale={locale} onChange={e => store.updateTime = e}/>
            </SearchFormItem> */}
          </SearchForm>
          {/* <div className='searchButtonContainer'>
              <Button loading={store.fetching} type="primary" style={{ marginRight: 10,fontSize:'12px',padding:'4px 10px' }} icon={<SearchOutlined />} onClick={() => {
                  handleSearch()
                }}>搜 索</Button>
              <Button loading={store.fetching} type="primary" style={{ marginRight: 10,fontSize:'12px',padding:'4px 10px' }} icon={<ReloadOutlined />} onClick={() => {
                    resetSearch()
                  }}>重 置</Button>
                <Button loading={store.fetching} type="primary" style={{fontSize:'12px',padding:'4px 10px' }} icon={<VerticalAlignBottomOutlined />} onClick={() => {
                  handleExport()
                }}>导 出</Button>
              <Button type="link" style={{ marginRight: 10,fontSize:'12px',padding:'4px 10px',}} onClick={() => {
                  setSearchType(!searchType)
                }}>{searchType?'普通搜索':'高级搜索'}</Button>
          </div> */}
        </div>
      </Card>
      <div className="mainBox">
        <Table/>
        </div>
      </div>
      
   
      {/* {store.formVisible && <Form/>} */}
    </React.Fragment>
  )
})